import { Platform, TurboModuleRegistry } from 'react-native'

const DIDIT_MODULE_NAME = 'SdkReactNative'

type DiditVerificationResult = {
  type: string
  error?: { message?: string }
}

type DiditStartVerification = (
  sessionToken: string,
  options: Record<string, unknown>,
) => Promise<DiditVerificationResult>

interface DiditNativeSdk {
  startVerification: DiditStartVerification
}

export function hasDiditNativeSdk(): boolean {
  if (Platform.OS === 'web') return false
  try {
    return Boolean(TurboModuleRegistry.get(DIDIT_MODULE_NAME))
  } catch {
    return false
  }
}

export async function loadDiditNativeSdk() {
  if (!hasDiditNativeSdk()) {
    throw new Error('DIDIT_NATIVE_MODULE_MISSING')
  }

  const sdk = await import('@didit-protocol/sdk-react-native')
  const startVerification = readStartVerification(sdk)
  if (!startVerification) {
    throw new Error('DIDIT_NATIVE_START_VERIFICATION_MISSING')
  }
  return { startVerification } satisfies DiditNativeSdk
}

function readStartVerification(value: unknown): DiditStartVerification | null {
  const record = asRecord(value)
  const defaultRecord = asRecord(record?.default)
  const candidate = record?.startVerification ?? defaultRecord?.startVerification
  return typeof candidate === 'function' ? (candidate as DiditStartVerification) : null
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>
  }
  return null
}
